import {ChangeDetectorRef, Component, Inject, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DetailPopup} from '../../../mapping-classes/detail-popup';
import {CostsTableComponent} from '../../../detail-table/costs/costs-table.component';
import {DomService} from '../../../../../../services/dom-service/dom.service';
import * as DetailTable from '../../../table-lib';
import {DetailPopupRequestModel} from '../../../services/popup/detail-popup-request.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './costs-popup.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})

export class CostsPopupComponent implements DetailPopup {
  @ViewChild('table', {read: ViewContainerRef}) tableContainer: ViewContainerRef;

  title: string;
  restrictedData: boolean;
  errorText: string;
  hasData = true;
  data;
  tableInstance;
  tableComponent;
  arrangement: string;
  emptyValuePlaceholder = '-';

  constructor(private domService: DomService, private changeRef: ChangeDetectorRef,
              public dialogRef: MatDialogRef<CostsPopupComponent>,
              @Inject(MAT_DIALOG_DATA) public inputData: any) {
    this.title = 'Kostenarrangement transacties';

    if (inputData.listOfError  && inputData.listOfError.length !== 0) {
      this.createErrorMessage(inputData);
      this.hasData = false;
    } else if (inputData.detailsViewObject) {
      this.data = inputData;
      this.restrictedData = inputData.detailsViewObject['restrictedData'];
      if (this.data.detailsViewObject.interestBankCode === 0) {
        this.arrangement = DetailPopupRequestModel.tableNumber + ' Organisatiestandaard';
      } else {
        this.arrangement = DetailPopupRequestModel.tableNumber + ' Bankstandaard';
      }
    }
  }

  ngAfterViewInit() {
    this.addValues(this.data);
    this.changeRef.detectChanges();
  }

  close(): void {
    this.dialogRef.close();
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Kosten transacties niet gevonden.';
      }
    }
  }

  addValues(response) {
    const detailsViewObject = response.detailsViewObject;
    this.createTable(detailsViewObject);
  }

  private createTable(detailsViewObject) {
    this.tableInstance = new DetailTable['Costs'](detailsViewObject);
    if (!this.tableContainer) {
      return null;
    }

    this.tableComponent = this.createCostsTable();
  }

  private createCostsTable() {
    const viewRef = this.domService.addComponentToDOM(CostsTableComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as CostsTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private setBasicComponentValues(componentToReturn) {
    componentToReturn.errorText = this.tableInstance.errorText;
    componentToReturn.showTable = (componentToReturn.errorText === null || componentToReturn.errorText === undefined);
    componentToReturn.restrictedData = this.restrictedData;
    componentToReturn.tableColumns = this.tableInstance.rowHeaders;
    componentToReturn.tableData = this.tableInstance.rowData;
    return componentToReturn;
  }
}
